<app-upload-view-component
    [config]="config"
    (emitData)="saveFile($event)"
></app-upload-view-component>
